import { motion } from "framer-motion";
import { IMG } from "../../data/site";

export const BrandStrip = () => (
  <section className="bg-[#0a0a0a] border-b border-white/10 py-10 md:py-12">
    <div className="mx-auto max-w-[1400px] px-6 md:px-10 flex flex-col md:flex-row items-center justify-center gap-6 md:gap-10">
      <span className="text-xs font-bold tracking-[0.3em] uppercase text-zinc-500">Proud Authorised Dealer</span>
      <div className="flex items-center gap-5">
        {[IMG.heroLogo, IMG.vidaLogo].map((src, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.1 }}
            className="bg-white rounded-md px-6 py-4 flex items-center justify-center shadow-lg shadow-black/30"
            data-testid={`brand-logo-${i}`}
          >
            <img src={src} alt={i === 0 ? "Hero MotoCorp" : "VIDA"} className="h-10 md:h-12 w-auto object-contain" />
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
